import axios from 'axios';
import { PublicClientApplication } from '@azure/msal-browser';

import { msalConfig } from 'authConfig';
import { getAccessToken, setAccessToken } from 'utils/access-token';

const msalInstance = new PublicClientApplication(msalConfig);

export default class BaseResource {
  constructor({ url = '', config = {} }) {
    // eslint-disable-next-line no-undef
    const baseURL = process.env.REACT_APP_API_AGENTSPACE_SERVICE;
    const headers = {
      Accept: 'application/json',
    };
    this.http = axios.create({
      ...config,
      baseURL,
      headers,
    });
    this.http.interceptors.request.use(
      async (config) => {
        const accessToken = getAccessToken();
        const updatedConfig = {
          ...config,
          headers: {
            ...config.headers,
            Authorization: `Bearer ${accessToken ?? ''}`,
          },
        };
        return updatedConfig;
      },
      (error) => Promise.reject(error)
    );

    /**
     * Response interceptor → handle expired tokens
     */
    this.http.interceptors.response.use(
      (response) => response,
      async (error) => {
        if (error.response?.status === 401) {
          const account = msalInstance.getActiveAccount();

          if (account) {
            try {
              const tokenResponse = await msalInstance.acquireTokenSilent({
                scopes: [msalConfig.auth.clientId],
                account,
              });

              setAccessToken(tokenResponse.idToken);
              error.config.headers.Authorization = `Bearer ${tokenResponse.idToken}`;
              return this.http(error.config);
            } catch (err) {
              msalInstance.loginRedirect();
            }
          } else {
            msalInstance.loginRedirect();
          }
        }

        return Promise.reject(error);
      }
    );

    this.url = url;
    this.initialConfig = config;
  }

  httpRequest(config = {}) {
    return this.http({
      url: this.url,
      ...this.initialConfig,
      ...config,
    });
  }

  get(config = {}) {
    return this.httpRequest({ method: 'get', ...config });
  }

  post(data, config = {}) {
    return this.httpRequest({ method: 'post', data, ...config });
  }

  put(data, config = {}) {
    return this.httpRequest({ method: 'put', data, ...config });
  }

  patch(data, config = {}) {
    return this.httpRequest({ method: 'patch', data, ...config });
  }

  delete(config = {}) {
    return this.httpRequest({ method: 'delete', ...config });
  }
}
